import React from 'react';
import { Outlet } from 'react-router-dom';

const DashboardMngPage = () => {
  return <Outlet />
};

export default DashboardMngPage;
